import { render, staticRenderFns } from "./tradeHome.vue?vue&type=template&id=b14262d6"
import script from "./tradeHome.vue?vue&type=script&lang=js"
export * from "./tradeHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports